import getBuyerAPIDomain from "../getBuyerAPIDomain";
import getEnvironment from "../getEnvironment";

const saveSearch = async (savedSearch: {
  searchName: string;
  url: string;
  notifyMe: boolean;
  deactivationDate: string;
  deleteOnDeactivation: boolean;
  authToken: string;
  isToUseAuthZero: boolean;
}) => {
  const { authToken, isToUseAuthZero, ...saveSearchData } = savedSearch;
  let headers: HeadersInit = {
    "Content-Type": "application/json",
  };
  const buyerAPIDomain = getBuyerAPIDomain(isToUseAuthZero);

  if (getEnvironment() === "localhost") {
    if (!process.env.TOKEN) {
      console.log("TOKEN variable not set.");
    }

    headers = { ...headers, Authorization: `Bearer ${process.env.TOKEN}` };
  }

  if (isToUseAuthZero) {
    headers = {
      ...headers,
      Authorization: `Bearer ${authToken}`,
    };
  }

  const res = await fetch(`${buyerAPIDomain.href}/savedsearch`, {
    method: "POST",
    headers,
    body: JSON.stringify(saveSearchData),
  });

  if (res.status === 200) {
    // try to deserialize and on failure return status code
    return res.json().catch(() => res);
  }
  return res;
};

export default saveSearch;
